interface MediaItem {
  image: string;
  imageAlt: string;
  title: string;
  duration: string;
  views: string;
  tag: string;
}

const mediaItems: MediaItem[] = [
  {
    image: "https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20abstract%20image%20with%20play%20button%20overlay%2C%20entertainment%20news%20theme%2C%20warm%20coral%20and%20amber%20tones%2C%20dark%20background%2C%20modern%20editorial%20design%2C%20clean%20composition&width=600&height=400&seq=media-01-91cg&orientation=landscape",
    imageAlt: "明星机场街拍视频",
    title: '独家：某一线女星机场素颜照曝光，真实状态引热议',
    duration: '03:25',
    views: '126.8万',
    tag: '独家',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20abstract%20image%20with%20play%20button%2C%20social%20media%20trending%20theme%2C%20warm%20rose%20and%20amber%20tones%2C%20dark%20background%2C%20editorial%20design&width=600&height=400&seq=media-02-91cg&orientation=landscape",
    imageAlt: "网红翻车现场视频",
    title: '直播翻车名场面：千万粉主播口误引发全网玩梗热潮',
    duration: '05:12',
    views: '98.3万',
    tag: '热门',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20abstract%20image%20with%20play%20button%2C%20variety%20show%20theme%2C%20warm%20amber%20and%20terracotta%20tones%2C%20dark%20background%2C%20editorial%20design&width=600&height=400&seq=media-03-91cg&orientation=landscape",
    imageAlt: "综艺未播片段",
    title: '综艺录制花絮流出：两位导师台下真实互动画面曝光',
    duration: '08:47',
    views: '87.5万',
    tag: '花絮',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20abstract%20image%20with%20play%20button%2C%20celebrity%20interview%20theme%2C%20warm%20coral%20tones%2C%20dark%20background%2C%20editorial%20design&width=600&height=400&seq=media-04-91cg&orientation=landscape",
    imageAlt: "艺人采访回应视频",
    title: '专访回应争议：当事人首次面对镜头详谈事件来龙去脉',
    duration: '12:30',
    views: '72.1万',
    tag: '专访',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20abstract%20image%20with%20play%20button%2C%20social%20event%20theme%2C%20warm%20amber%20and%20rose%20tones%2C%20dark%20background%2C%20editorial%20design&width=600&height=400&seq=media-05-91cg&orientation=landscape",
    imageAlt: "社会热点视频合集",
    title: '街头实拍：路人偶遇明星私密聚餐，全程高清实拍',
    duration: '02:58',
    views: '65.4万',
    tag: '实拍',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-2">精彩视频</h2>
        <p className="text-foreground-500 text-sm text-center mb-10">编辑精选热门视频，点击立即在线观看</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {mediaItems.map((item) => (
            <a
              key={item.title}
              href="#media"
              className="group bg-background-50 rounded-xl overflow-hidden hover:bg-background-200/50 transition-colors duration-200 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-200">
                    <i className="ri-play-fill text-white text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-white text-xs font-medium whitespace-nowrap">
                  {item.duration}
                </span>
                <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-accent-500/90 text-white text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-3">
                <h3 className="text-xs font-medium text-foreground-800 line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {item.views} 次观看
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}